import { mapGetters, mapActions } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { volume } from '@/api/vissue'
import journal from '@/api/journal'
import article from '@/api/article'
import operation from '@/api/operation'
import baiduScholar from '@/api/scholar'
import crossref from '@/api/crossref'
import { settingJournal } from '@/api/setting'
import help from '@/utils/help'
import tipInfoDialog from './tipInfo.dialog'
const columns = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 170,
    dataIndex: 'code',
    slot: 'code'
  },
  {
    title: '',
    enTitle: 'DOI',
    width: 220,
    dataIndex: 'doi'
  },
  {
    title: '',
    enTitle: 'DOI Status',
    width: 150,
    dataIndex: 'doied',
    slot: 'doied'
  },
  {
    title: '',
    enTitle: 'Title',
    width: 400,
    dataIndex: 'titleText',
    slot: 'omis'
  },
  // {
  //   title: '',
  //   enTitle: 'Assigned Editor',
  //   width: 120,
  //   dataIndex: 'readNum',
  //   slot: 'readNum'
  // },
  {
    title: '',
    enTitle: 'Submission Time',
    width: 170,
    dataIndex: 'submittedDate',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'status',
    slot: 'publish'
  },
  {
    title: '',
    enTitle: 'Baidu Scholar',
    width: 130,
    dataIndex: 'status',
    slot: 'baiduStatus'
  },
  {
    title: '',
    enTitle: 'Published Time',
    width: 150,
    dataIndex: 'publishedDate',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Updated Time',
    width: 170,
    dataIndex: 'updateTime',
    slot: 'time',
    sort: true
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 120,
    dataIndex: 'operator',
    slot: 'operator'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 190,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: { SiteSearchGroup, tipInfoDialog },
  data() {
    return {
      columns,
      showAdv: false,
      journalList: [],
      volumeList: [],
      issueList: [],
      dataSource: [],
      params: {
        released: '',
        journalId: '',
        volumeId: '',
        issueId: '',
        status: ''
      },
      countObj: {
        ALL: 0,
        PUBLISHED: 0,
        UNPUBLISHED: 0,
        RETRACTION: 0
      },
      emptyText: {
        ALL: 'There is no manuscript or article.',
        PUBLISHED: 'There is no article which is online.',
        UNPUBLISHED: 'There is no manuscript which is pending online.',
        RETRACTION: 'There is no article which is retraction .'
      },
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      alertDate: {},
      isVisable: false,
      inputData: {}
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      user: 'getUser'
    })
  },
  async mounted() {
    await this.getJournalList()
  },
  methods: {
    ...mapActions(['updateLoading']),

    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      this.updateLoading(true)
      const { list, pageIndex, pageSize, total } = await article.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
      this.getCount()
      this.updateLoading(false)
    },
    async getJournalList() {
      this.journalList = await journal.userGet()
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      if (!this.params.journalId) {
        return
      }
      this.getVolumeCode(this.params.journalId)
      this.getSeetingJournal()
    },
    async getSeetingJournal() {
      this.alertDate = await settingJournal.get({
        journalId: this.params.journalId
      })
    },
    async getVolumeCode(journalId) {
      this.volumeList = await volume.getCode({ journalId })
      this.params.volumeId = ''
      this.params.issueId = ''
      this.getList()
    },
    getIssueCode(val) {
      const arr = this.volumeList.find(item => {
        if (item.id === val) {
          return item
        }
      })
      this.issueList = arr.issueCodeList
      this.params.issueId = ''
      this.getList()
    },
    async getCount() {
      const res = await article.getCount(this.params)
      this.countObj = {
        ALL: 0,
        PUBLISHED: 0,
        UNPUBLISHED: 0,
        RETRACTION: 0
      }
      res.forEach(item => {
        this.countObj[item.status] = item.count || 0
        this.countObj.ALL += item.count || 0
      })
    },
    handleClear() {
      this.params.search = ''
      this.params.volumeId = ''
      this.params.issueId = ''
      this.getList()
    },
    changeStatus(val) {
      this.params.status = val
      this.getList()
    },
    add() {
      this.$router.push(
        `/publishing/publication/add?journalId=${this.params.journalId}`
      )
    },
    edit(val) {
      window.open(
        `/publishing/publication/${val.id}?journalId=${this.params.journalId}`,
        '_blank'
      )
      // this.$router.push(
      //   `/publishing/publication/${val.id}?journalId=${this.params.journalId}`
      // )
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this article?',
        content:
          'Please be aware of once this article is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await article.del(val.id)
        await operation.add({
          authorityCode: 'WEBSITE.PUBLISHING.DELETE',
          type: 'DELETE',
          info: `Delete The Article:  ${val.doi}`,
          detail: `【DOI】: ${val.doi}`
        })
        this.$message.success({
          title: 'Success',
          content: 'This Article has been deleted!'
        })
        this.getList()
      })
    },
    async able(val, status) {
      // if(val.revisedDate - val.submittedDate)
      // if(val.acceptDate - val.revisedDate)
      // if(val.publishedDate - val.acceptDate)
      let flag1 = false,
        flag2 = false,
        flag3 = false
      if (val.revisedDate && val.submittedDate) {
        flag1 =
          this.$moment(val.revisedDate).diff(
            this.$moment(val.submittedDate),
            'days'
          ) < this.alertDate.RECEIVED_REVISED_DATE
      }
      if (val.acceptDate && val.revisedDate) {
        flag2 =
          this.$moment(val.acceptDate).diff(
            this.$moment(val.revisedDate),
            'days'
          ) < this.alertDate.REVISED_ACCEPT_DATE
      }

      if (val.publishedDate && val.acceptDate) {
        flag3 =
          this.$moment(val.publishedDate).diff(
            this.$moment(val.acceptDate),
            'days'
          ) < this.alertDate.ACCEPT_PUBLISHED_DATE
      }

      // console.log(
      //   flag1,
      //   flag2,
      //   flag3,
      //   'flag',
      //   this.$moment(val.revisedDate).diff(this.$moment(val.submittedDate)),
      //   this.alertDate.RECEIVED_REVISED_DATE
      // )
      if (status === 'PUBLISHED' && (flag1 || flag2 || flag3)) {
        this.inputData = val
        this.inputData.__status = status
        this.inputData.__flag1 = flag1
        this.inputData.__flag2 = flag2
        this.inputData.__flag3 = flag3
        this.isVisable = true
        return
      }
      this.publishAfter(status, val)
    },
    cancel() {
      this.isVisable = false
    },
    async publishAfter(status, val) {
      const { id, version } = val
      const oldStatus = val.status
      await article.changeStatus([
        {
          id,
          status,
          version
        }
      ])
      this.isVisable = false
      if (oldStatus === 'RETRACTION' || status === 'RETRACTION') {
        await operation.add({
          authorityCode: 'WEBSITE.PUBLISHING.WITHDRAW',
          type: 'WITHDRAW',
          info: `Withdraw/Cancel Withdraw: ${val.doi}`,
          detail: `Change from 【${
            status === 'PUBLISHED' ? 'Withdraw' : 'Cancel Withdraw'
          }】 to 【${status === 'PUBLISHED' ? 'Cancel Withdraw' : 'Withdraw'}】`
        })
      } else {
        await operation.add({
          authorityCode: 'WEBSITE.PUBLISHING.PUBLISH',
          type: 'PUBLISH',
          info: `Publish/Unpublish: ${val.doi}`,
          detail: `Change from 【${
            status === 'PUBLISHED' ? 'Unpublish' : 'Publish'
          }】 to 【${status === 'PUBLISHED' ? 'Publish' : 'Unpublish'}】`
        })
      }
      let content = `This Article has been ${status.toLowerCase()}!`
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    async imp(files) {
      const file = files[0]
      const rightType = [
        'application/x-zip-compressed',
        'application/zip'
      ].includes(file.type)

      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }

      const data = new FormData()
      data.append('file', file)
      data.append('journalId', this.params.journalId)

      const res = await article.import(data)
      await operation.add({
        authorityCode: 'WEBSITE.PUBLISHING.IMPORT',
        type: 'IMPORT',
        info: `Article Data Import.`,
        detail: `【Article(s)】: ${res}`
      })
      this.$message.success({
        title: 'Success',
        content: 'The article is imported successfully'
      })
    },
    async exp() {
      const res = await article.export(this.params)
      await operation.add({
        authorityCode: 'WEBSITE.PUBLISHING.EXPORT',
        type: 'EXPORT',
        info: `Article Data Export.`,
        detail: `Article Data Export.`
      })
      help.download(res.url, res.fileName)
    },
    changeJournal(val) {
      this.getVolumeCode(val)
      localStorage.setItem('journalId', val)
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },
    async openWebsite(val) {
      const { name } = await journal.query(val.journalId)
      let url = `/journal/${name}/test/article/${
        val.id
      }?token=${localStorage.getItem('token')}`
      const { host } = window.location
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        url = 'http://192.168.4.21:9001' + url
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        url = 'http://www.imrpress.tech' + url
      } else if (host.includes('imrpress.tech:8100')) {
        url = 'http://www.imrpress.tech:9000' + url
      } else if (host.includes('propub.com')) {
        url = 'https://www.imrpress.com' + url
      } else {
        url = 'http://192.168.4.21:9001' + url
      }
      help.openWindow(url)
    },
    openPdf(val, type) {
      let url = ''
      if (type === 'pdf') {
        url = `${this.domain}/${val.pdfFile.path}`
      } else {
        url = `${this.domain}/${val.xmlFile.path}`
      }
      help.openWindow(url)
    },
    async refreshBaidu(id) {
      await baiduScholar.refresh(id)
      this.$message.success({
        title: 'Success',
        content: 'Baidu Scholar synchronization success！'
      })
      this.getList()
    },
    updateDOI(val, flag) {
      if (val.doied && flag) {
        this.$message.error({
          title: 'Error',
          content: 'DOI have already registered!'
        })
        return
      }
      let type = val.doied ? 'resetDoi' : 'articalDoi'
      if (flag === 'offline') {
        type = 'articalDoiOffline'
      }
      const title = val.doied
        ? 'DOI Registration Rollback?'
        : 'Offline Registration?'
      const content = val.doied
        ? 'The DOI Status becomes unregistered after confirmation.'
        : 'The DOI Status becomes registered after confirmation.'
      this.$confirm({
        title: title,
        content: content,
        type: 'warning',
        icon: 'iconDetails'
      }).then(async () => {
        await crossref[type]({
          articleId: val.id,
          version: val.version
        })
        this.$message.success({
          title: 'Success',
          content:
            'Operate successfully, the registration result will be sent later.'
        })
        this.getList()
      })
    }
  }
}
